/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterItemFieldsFragment = {
  __typename: "MatterItem";
  type: Types.GqlMatterItemType;
  id?: string | null;
  name?: string | null;
  role?: string | null;
  isClient?: boolean | null;
  isOtherSide?: boolean | null;
  contact?: { __typename: "Contact"; id: string } | null;
  subItems?: Array<{
    __typename: "MatterItem";
    type: Types.GqlMatterItemType;
    id?: string | null;
    name?: string | null;
    role?: string | null;
    isClient?: boolean | null;
    isOtherSide?: boolean | null;
    contact?: { __typename: "Contact"; id: string } | null;
  } | null> | null;
};

export const MatterItemFieldsFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "matterItemFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatterItem" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "role" } },
          { kind: "Field", name: { kind: "Name", value: "isClient" } },
          { kind: "Field", name: { kind: "Name", value: "isOtherSide" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "contact" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subItems" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "role" } },
                { kind: "Field", name: { kind: "Name", value: "isClient" } },
                { kind: "Field", name: { kind: "Name", value: "isOtherSide" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contact" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlMatterItemFieldsFragment, unknown>;
